import React from 'react';
import BaseTimelineRecordLayout from 'domain/shared/timeline/layout/BaseTimelineRecordLayout';
import useCrmNoteService, {
  DELETE_CRM_NOTE_PERMISSION,
  UPDATE_CRM_NOTE_PERMISSION,
} from 'domain/sales/shared/timeline/note/crmNoteService';
import { useShowContext } from 'framework/show';
import { TimelineType } from 'domain/shared/timeline/layout/BaseTimelineRecordLayout/timelineLayoutHelper';
import { useListContext } from 'framework/list';
import { TimelineContextData } from 'framework/ui/timeline';
import { useParams } from 'react-router-dom';
import { DeleteTimelineRecordButton, EditTimelineRecordButton } from 'domain/shared/timeline/button';
import { PinTimelineButton } from 'domain/shared/timeline';

const NoteTimelineRecordLayout = ({ onEdit, isPinned, ...props }: any) => {
  const opportunityId = useParams<Dictionary<string>>().id!;
  const { deleteById } = useCrmNoteService();
  const { data } = useShowContext();
  const id = data.getValueBySource('id');
  const timelineId = data.getValueBySource('timelineId');
  const { updateInList, pinTimelineAction }: TimelineContextData = useListContext();

  const buttons = [
    <EditTimelineRecordButton permissionToCheck={UPDATE_CRM_NOTE_PERMISSION} key="edit" onEdit={onEdit} />,
    <DeleteTimelineRecordButton
      permissionToCheck={DELETE_CRM_NOTE_PERMISSION}
      deleteMethod={deleteById}
      key="add"
      id={id}
      timelineId={timelineId}
      entityName="note"
    />,
  ];

  return (
    <BaseTimelineRecordLayout
      actions={[
        <PinTimelineButton
          pinStatus={isPinned}
          pinMethod={async () => {
            const response = await pinTimelineAction!(opportunityId, timelineId, !isPinned);
            updateInList!(response?.id, response);
          }}
        />,
      ]}
      timelineType={TimelineType.NOTE}
      buttons={buttons}
      {...props}
    />
  );
};

export default NoteTimelineRecordLayout;
